<template>
  <button
    class="btn"
    @click="handleClick"
    :disabled="disabled || loading"
    type="button"
    :class="{ 'is-disabled': disabled }"
  >
    <transition name="blink" mode="out-in">
      <template v-if="loading">
        <div class="dot">
          <i></i>
          <i></i>
          <i></i>
        </div>
      </template>
      <template v-else>
        <span v-if="$slots.default">
          <slot></slot>
        </span>
      </template>
    </transition>
  </button>
</template>
<script>
export default {
  props: {
    loading: Boolean,
    disabled: Boolean
  },
  methods: {
    handleClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>
<style lang="scss" scoped>
.blink-enter-active {
  transition: opacity 0.24s ease-out;
}

.blink-leave-active {
  transition: opacity 0.24s ease-out;
}

.blink-enter {
  opacity: 0;
}
.blink-leave-to {
  opacity: 0;
}
@keyframes breathe {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.btn {
  position: relative;
  -webkit-appearance: none;
  -webkit-user-select: none;
  width: 100%;
  height: 36px;
  line-height: 36px;
  font-size: 17px;
  white-space: nowrap;
  text-align: center;
  color: #fff;
  margin: 0;
  padding: 0;
  outline: 0;
  box-sizing: border-box;
  background-color: #0081ff;
  border-radius: 4px;
  border: none;
  transition-property: background-color, opacity, color;
  transition-duration: 0.12s;

  &:hover {
    background-color: #0081ff;
    opacity: 0.8;
  }

  &:active {
    background-color: #0079f0;
    opacity: 1;
  }
  &.is-loading {
    opacity: 0.8;
  }
  &.is-disabled {
    color: #8cc5ff;
    background-color: #ecf5ff;
  }
  .dot {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    i {
      display: block;
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #fff;
      opacity: 0;
      animation: breathe 0.9s infinite linear alternate;
      &:nth-child(1) {
        left: 50%;
        top: 50%;
        margin-left: -25px;
        margin-top: -5px;
        animation-delay: 0s;
      }
      &:nth-child(2) {
        left: 50%;
        top: 50%;
        margin-left: -5px;
        margin-top: -5px;
        animation-delay: 0.3s;
      }
      &:nth-child(3) {
        left: 50%;
        top: 50%;
        margin-left: 15px;
        margin-top: -5px;
        animation-delay: 0.6s;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/components/vButton.vue